module.exports = __webpack_public_path__ + "static/media/caro_img_6.c25ca3b4.webp";